module.exports = __webpack_public_path__ + "static/img/advantage1.35f48ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/advantage1.png
// module id = 2zDO
// module chunks = 11